/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require('./bootstrap');

window.Vue = require('vue');

/**
 * The following block of code may be used to automatically register your
 * Vue components. It will recursively scan this directory for the Vue
 * components and automatically register them with their "basename".
 *
 * Eg. ./components/ExampleComponent.vue -> <example-component></example-component>
 */

const files = require.context('./', true, /\.vue$/i);
files.keys().map(key => Vue.component(key.split('/').pop().split('.')[0], files(key).default));

//Vue.component('example-component', require('./components/ExampleComponent.vue').default);

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */


import Vue from 'vue'
import InfiniteLoading from 'vue-infinite-loading';
import Transitions from 'vue2-transitions'
import vueJquery from 'vue-jquery'
import VueLazyload from 'vue-lazyload'

let VueScrollTo = require('vue-scrollto');

Vue.use(InfiniteLoading, { /* options */ });
Vue.use(Transitions)
Vue.use(vueJquery)
Vue.use(VueScrollTo)

Vue.use(VueLazyload, {
    observer: true,
})

Vue.use(VueScrollTo, {
    container: 'body',
    duration: 500,
    easing: 'ease',
    offset: 0,
    force: true,
    cancelable: true,
    onStart: false,
    onDone: false,
    onCancel: false,
    x: false,
    y: true
})

Vue.component('slide-show', require('fh-components/slide-show'))

import App from './components/App'

Vue.prototype.window = window

new Vue(App).$mount('#app')


